module.exports = __webpack_public_path__ + "static/media/EM5300-FOPD_edited_no_cups_edited_HB_v2_No_Grinder_No_Cups 1.786254e2.svg";